import Axios from 'axios'
import { getHeader, reportUrl, settingUrl } from '../config'

const state = {
  rowsTable: [],
  currentMenu: '',
  mainMenu: [{
    name: 'dashboard',
    menu: [{
      name: 'Dashboard',
      header: null,
      url: 'home',
      permission: null,
      subMenu: []
    }, {
      name: 'Report',
      header: 'Report',
      url: null,
      permission: 'sub_dashboard_report',
      subMenu: [{
        header: 'Purchasing',
        list: [{
          name: 'Summary by Order',
          url: 'product.summary-by-orders',
          permission: null
        }, {
          name: 'Purchasing Order Monitoring',
          url: 'purchasing.order.monitoring',
          permission: null
        }, {
          name: 'Hutang',
          url: 'purchasing.hutang-overdue',
          permission: null
        }, {
          name: 'Laporan Pembelian',
          url: 'purchasing.report-by-vendor',
          permission: null
        }, {
          name: 'Laporan Pembayaran Vendor',
          url: 'purchasing.report-payment',
          permission: null
        }, {
          name: 'Purchasing Monitoring',
          url: 'purchasing.monitoring',
          permission: null
        }]
      }, {
        header: 'Sales',
        list: [{
          name: 'Laporan Kas Kecil / Pengeluaran',
          url: 'cash-on-hand.report-kas-kecil',
          permission: null
        }, {
          name: 'Laporan Laba Kotor',
          url: 'sale.report-sales-by-product-category',
          permission: 'report_sales_laba_kotor'
        }, {
          name: 'Piutang Salesman',
          url: 'sale.piutang-salesman',
          permission: null
        }, {
          name: 'Sales Order Monitoring',
          url: 'sale.order.monitoring',
          permission: null
        }, {
          name: 'Sales Monitoring',
          url: 'sale.monitoring',
          permission: null
        }, {
          name: 'Laporan Retur Product',
          url: 'return.report-by-product',
          permission: null
        }, {
          name: 'Laporan Komisi Salesman',
          url: 'sale.report-salesman',
          permission: null
        }, {
          name: 'Piutang Overdue',
          url: 'sale.piutang-overdue',
          permission: null
        }, {
          name: 'Rekap Piutang',
          url: 'sale.rekap-piutang',
          permission: null
        }]
      }, {
        header: 'Finance',
        list: [{
          name: 'Laporan Penerimaan Tagihan',
          url: 'sale.payment-salesman-area',
          permission: null
        }, {
          name: 'Laporan Giro',
          url: 'payment.report-giro',
          permission: null
        }, {
          name: 'Laba Rugi',
          url: 'laba-rugi',
          permission: 'finance_laba_rugi'
        }, {
          name: 'Tax Monitoring',
          url: 'report.tax-monitoring',
          permission: null
        }, {
          name: 'Laporan Audit',
          url: 'report.audit',
          permission: null
        }, {
          name: 'Kartu Stock',
          url: 'product.cogs',
          permission: null
        }]
      }, {
        header: 'Manufacture',
        list: [{
          name: 'Summary',
          url: 'manufacture.report-summary',
          permission: 'report_manufacture_summary'
        }, {
          name: 'Summary Weekly',
          url: 'manufacture.report-summary-weekly',
          permission: null
        }, {
          name: 'Summary Product',
          url: 'manufacture.report-summary-product',
          permission: 'report_manufacture_summary_product'
        }, {
          name: 'Report Film',
          url: 'manufacture.report-summary-on-hand',
          permission: null
        }]
      }]
    }, {
      name: 'Report Stock',
      header: 'Report Stock',
      url: null,
      permission: 'sub_dashboard_report_stock',
      subMenu: [{
        header: 'Stock',
        list: [{
          name: 'Sale Order Monitoring',
          url: 'sale.order.monitoring',
          permission: null
        }, {
          name: 'Arus Stok',
          url: 'product.stock-flow',
          permission: null
        }, {
          name: 'Summary Cost',
          url: 'product-summary.cost',
          permission: null
        }, {
          name: 'Customer',
          url: 'customer',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'manufacture',
    menu: [{
      name: 'Manufacture',
      header: 'Manufacture',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Manufacture',
        list: [{
          name: 'List',
          url: 'manufacture',
          permission: null
        }]
      }, {
        header: 'Film Process',
        list: [{
          name: 'On Hand',
          url: 'inventory.on-hand',
          permission: null
        }, {
          name: 'Kartu Stock',
          url: 'inventory.on-hand-kartu-stock',
          permission: null
        }, {
          name: 'Arus Stok',
          url: 'product.stock-flow',
          permission: null
        }]
      }, {
        header: 'Product',
        list: [{
          name: 'Summary',
          url: 'product-summary',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'inventory',
    menu: [{
      name: 'Inventory',
      header: 'Inventory',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Inventory',
        list: [{
          name: 'List',
          url: 'inventory',
          permission: null
        }, {
          name: 'Transfer',
          url: 'inventory-transfer',
          permission: null
        }, {
          name: 'Convert',
          url: 'inventory-convert',
          permission: 'convert_submenu_view'
        }, {
          name: 'Inventory Adjust',
          url: 'adjust',
          permission: 'adjust_submenu_view'
        }]
      }]
    }, {
      name: 'Product',
      header: 'Product',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Product',
        list: [{
          name: 'List',
          url: 'product',
          permission: null
        }, {
          name: 'Summary',
          url: 'product-summary',
          permission: null
        }, {
          name: 'History',
          url: 'product-history',
          permission: null
        }]
      }, {
        header: 'Price',
        list: [{
          name: 'Price List',
          url: 'setting.pricelist',
          permission: null
        }, {
          name: 'Kartu Stock (HPP)',
          url: 'cost',
          permission: null
        }, {
          name: 'Jounal',
          url: 'journal',
          permission: null
        }]
      }, {
        header: 'Setting',
        list: [{
          name: 'Unit Of Measure',
          url: 'setting.uom',
          permission: null
        }, {
          name: 'Product Category',
          url: 'setting.pc',
          permission: null
        }, {
          name: 'Product Type',
          url: 'setting.pdt',
          permission: null
        }, {
          name: 'Warehouse',
          url: 'master.warehouse',
          permission: null
        }, {
          name: 'Vendor',
          url: 'vendor',
          permission: null
        }, {
          name: 'Variant',
          url: 'variant',
          permission: null
        }]
      }]
    }, {
      name: 'Purchasing',
      header: 'Purchasing',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Purchasing',
        list: [{
          name: 'Order',
          url: 'purchasing',
          permission: null
        }, {
          name: 'Type',
          url: 'purchasing.type',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'purchasing',
    menu: [{
      name: 'Purchasing',
      header: 'Purchasing',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Purchasing',
        list: [{
          name: 'Order',
          url: 'purchasing.order',
          permission: null
        }, {
          name: 'Pembelian',
          url: 'purchasing',
          permission: null
        }, {
          name: 'Payment',
          url: 'purchasing.payment-group',
          permission: null
        }, {
          name: 'Retur',
          url: 'purchasing.return',
          permission: null
        }, {
          name: 'Import Tax',
          url: 'purchasing.import-tax',
          permission: null
        }]
      }]
    }, {
      name: 'Product',
      header: 'Product',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Product',
        list: [{
          name: 'List',
          url: 'product',
          permission: null
        }, {
          name: 'Summary',
          url: 'product-summary',
          permission: null
        }, {
          name: 'Summary Cost',
          url: 'product-summary.cost',
          permission: 'product_summary_cost_view_cost'
        }, {
          name: 'Kartu Stock (HPP)',
          url: 'product.cogs',
          permission: 'product_stock_card_cogs'
        }, {
          name: 'Stock Close',
          url: 'product.stock-close',
          permission: null
        }, {
          name: 'Product Sales Journal Check',
          url: 'product.journal-sales-check',
          permission: null
        }]
      }, {
        header: 'Setting',
        list: [{
          name: 'Unit Of Measure',
          url: 'setting.uom',
          permission: null
        }, {
          name: 'Product Category',
          url: 'setting.pc',
          permission: null
        }, {
          name: 'Product Type',
          url: 'setting.pdt',
          permission: null
        }, {
          name: 'Warehouse',
          url: 'master.warehouse',
          permission: null
        }, {
          name: 'Vendor',
          url: 'vendor',
          permission: null
        }]
      }]
    }, {
      name: 'Inventory',
      header: 'Inventory',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Inventory',
        list: [{
          name: 'List',
          url: 'inventory',
          permission: null
        }, {
          name: 'Convert',
          url: 'inventory-convert',
          permission: 'convert_submenu_view'
        }, {
          name: 'Inventory Adjust',
          url: 'adjust',
          permission: 'adjust_submenu_view'
        }]
      }]
    }]
  }, {
    name: 'master',
    menu: [{
      name: 'Master',
      header: 'Master',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Master',
        list: [{
          name: 'Warehouse',
          url: 'master.warehouse',
          permission: null
        }, {
          name: 'Branch',
          url: 'master.branch',
          permission: null
        }, {
          name: 'Company',
          url: 'company',
          permission: null
        }, {
          name: 'Employee',
          url: 'employee',
          permission: null
        }]
      }, {
        header: 'Finance',
        list: [{
          name: 'Bank',
          url: 'master.bank',
          permission: null
        }, {
          name: 'Bank Group',
          url: 'master.bg',
          permission: null
        }]
      }]
    }, {
      name: 'Manage Lock',
      header: null,
      url: 'lock',
      permission: null,
      subMenu: []
    }]
  }, {
    name: 'hrm',
    menu: [{
      name: 'Human Resources',
      header: 'Human Resources',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Employee',
        list: [{
          name: 'List',
          url: 'employee',
          permission: null
        }, {
          name: 'Job Position',
          url: 'setting.jp',
          permission: null
        }, {
          name: 'Area',
          url: 'setting.area',
          permission: null
        }, {
          name: 'User',
          url: 'setting.user',
          permission: null
        }, {
          name: 'Role',
          url: 'setting.role',
          permission: null
        }]
      }]
    }, {
      name: 'Sales & Project',
      header: 'Sales & Project',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Sales',
        list: [{
          name: 'Survey',
          url: 'sale.survey',
          permission: null
        }, {
          name: 'Order',
          url: 'sale.order',
          permission: null
        }, {
          name: 'Sales',
          url: 'sales',
          permission: null
        }]
      }, {
        header: 'Project',
        list: [{
          name: 'List',
          url: 'project',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'customer',
    menu: [{
      name: 'Customer',
      header: 'Customer',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Customer',
        list: [{
          name: 'List',
          url: 'customer',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'service',
    menu: [{
      name: 'Service',
      header: null,
      url: 'workshop',
      permission: null,
      subMenu: [{
        header: 'Service',
        list: [{
          name: 'Service',
          url: 'workshop',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'project',
    menu: [{
      name: 'Project',
      header: null,
      url: 'project',
      permission: null,
      subMenu: []
    }, {
      name: 'Sales',
      header: 'Sales',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Sales',
        list: [{
          name: 'Survey',
          url: 'sale.survey',
          permission: null
        }, {
          name: 'Order',
          url: 'sale.order',
          permission: null
        }, {
          name: 'Sales',
          url: 'sales',
          permission: null
        }]
      }]
    }, {
      name: 'Customer',
      header: null,
      url: 'customer',
      permission: null,
      subMenu: []
    }]
  }, {
    name: 'sales',
    menu: [{
      name: 'Sales',
      header: 'Sales',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Sales',
        list: [{
          name: 'Order',
          url: 'sale.order',
          permission: null
        }, {
          name: 'Sales',
          url: 'sales',
          permission: null
        }, {
          name: 'Retur',
          url: 'sales.return',
          permission: null
        }, {
          name: 'Import Tax',
          url: 'sale.import-tax',
          permission: null
        }]
      }, {
        header: 'Payment',
        list: [{
          name: 'Payment',
          url: 'sale.payment-group',
          permission: null
        }, {
          name: 'Payment by Outstanding',
          url: 'payment.payment-group',
          permission: null
        }]
      }, {
        header: 'Report',
        list: [{
          name: 'Laba Kotor',
          url: 'sale.report-laba',
          permission: 'sale_laba_kotor_view'
        }, {
          name: 'Arus Stok',
          url: 'product.stock-flow',
          permission: null
        }]
      }, {
        header: 'Etc',
        list: [{
          name: 'Komisi Sales',
          url: 'sale.sale-commission',
          permission: null
        }, {
          name: 'Customer',
          url: 'customer',
          permission: null
        }, {
          name: 'Area',
          url: 'setting.area',
          permission: null
        }, {
          name: 'Term & Condition',
          url: 'term.condition',
          permission: null
        }, {
          name: 'Unit',
          url: 'unit',
          permission: null
        }, {
          name: 'Unit Type',
          url: 'unit.type',
          permission: null
        }, {
          name: 'Workshop',
          url: 'workshop',
          permission: null
        }]
      }]
    }, {
      name: 'Customer',
      header: null,
      url: 'customer',
      permission: null,
      subMenu: []
    }, {
      name: 'Area',
      header: null,
      url: 'setting.area',
      permission: null,
      subMenu: []
    }]
  }, {
    name: 'salesman',
    menu: [{
      name: 'Salesman',
      header: 'Salesman',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Salesman',
        list: [{
          name: 'Order',
          url: 'sale.salesman-order',
          permission: null
        }]
      }]
    }]
  }, {
    name: 'finance',
    menu: [{
      name: 'Finance',
      header: 'Finance',
      url: null,
      permission: null,
      subMenu: [{
        header: 'Finance',
        list: [{
          name: 'Kas Kecil',
          url: 'cash-on-hand',
          permission: null
        }, {
          name: 'Kas Besar',
          url: 'finance.kas-besar',
          permission: null
        }, {
          name: 'Kas Produksi Pintu',
          url: 'finance.kas-produksi-pintu',
          permission: null
        }, {
          name: 'Kas Produksi Fiber',
          url: 'finance.kas-produksi-fiber',
          permission: null
        }, {
          name: 'Kas Piutang',
          url: 'finance.kas-piutang',
          permission: null
        }, {
          name: 'Kas Besar Piutang',
          url: 'finance.kas-besar-piutang',
          permission: 'finance_kas_besar_piutang_menu_view'
        }]
      }, {
        header: 'Accounting',
        list: [{
          name: 'Journal',
          url: 'journal',
          permission: null
        }, {
          name: 'Journal System',
          url: 'journal.system',
          permission: null
        }, {
          name: 'Buku Besar',
          url: 'buku-besar',
          permission: null
        }, {
          name: 'Buku Besar Persediaan',
          url: 'finance.buku-besar-persediaan',
          permission: 'finance_buku_besar_persediaan'
        }, {
          name: 'Laba Rugi',
          url: 'laba-rugi',
          permission: 'finance_laba_rugi'
        }, {
          name: 'Neraca',
          url: 'neraca.detail',
          permission: 'finance_neraca'
        }, {
          name: 'Template',
          url: 'journal.template',
          permission: null
        }, {
          name: 'Chart Of Account',
          url: 'coa',
          permission: null
        }, {
          name: 'Journal Set',
          url: 'journal-set-all',
          permission: null
        }]
      }, {
        header: 'Asset',
        list: [{
          name: 'Asset',
          url: 'asset',
          permission: null
        }, {
          name: 'Asset Type',
          url: 'asset.type',
          permission: null
        }]
      }]
    }]
  }],
  notificationList: [],
  settingList: []
}

const mutations = {
  SET_ROW_TABLE (state, obj) {
    state.rowsTable = obj
  },
  SET_CURRENT_MENU (state, obj) {
    state.currentMenu = obj
  },
  SET_NOTIFICATION_LIST (state, obj) {
    state.notificationList = obj
  },
  SET_SETTING_LIST (state, obj) {
    state.settingList = obj
  }
}

const actions = {
  getRowTable: ({ commit }) => {
    var data = [
      {
        row: 10
      },
      {
        row: 25
      },
      {
        row: 50
      },
      {
        row: 100
      }]
    commit('SET_ROW_TABLE', data)
  },
  getNotification: ({ commit }) => {
    console.log('get notif vuex')
    Axios.get(reportUrl + '/notification', { headers: getHeader() })
      .then(response => {
        commit('SET_NOTIFICATION_LIST', response.data.data)
      })
  },
  getSettingList: ({ commit }) => {
    Axios.get(settingUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_SETTING_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
